import { lazy } from "react"

const PinListPage$$__react__lazy__component = lazy(() => 
    import("./PinListPage__original__module.mjs")
        .then(module => module.get_$$PinListPage$$PinListPage$$react__component$$3gv26ju6pi6is())
        .then(component => ({ default: component }))
)

export const get_$$PinListPage$$PinListPage$$react__component$$3gv26ju6pi6is = () => PinListPage$$__react__lazy__component